import { FilterObject } from 'src/app/dataLayer/ProductsModels/Helpers/FilterObject';
import { gql } from "apollo-angular";
import { product_details_resolver_interface } from 'src/app/dataLayer/ProductsModels/Entities/product.model';
import { environment } from 'src/environments/environment';






export const SINGLE_PRODUCT_QUERY = (product: product_details_resolver_interface, lang: string)=>{

   let query_param1 = lang === 'en' ? 'name_enEq: ' + `"${product.product_name}"` : 'name_arEq: ' + `"${product.product_name}"`;
   let query_param2 = 'id: ' + product.product_id;

   let query_params = `${query_param1}, ${query_param2}`


   return gql`
   {

      products(Function:"Details", ${query_params})
      {
         id
         min_reserve
         max_reserve
         can_reserve
         photo
         sub_category_id
         offers{
         id
         percentage
         product_id
         }
         subcat
         {
            name: name_${lang}
         }
         short_description: short_description_${lang}
         discount
         price
         products_photos
         {
            photo
         }
         attributes
         {
            id
            name: name_${lang}
            attribute_type_id
            attributetype {
              is_photo
            }
            attributes_options
            {
              id
              product_optionsId
              attributes_optionsId
              name: name_${lang}
               price
               is_base_price
               required
               max_check
               created
               value
            }
         }
         description: description_${lang}
         specifications_options
         {
            id
            name: name_${lang}
            specification
            {
               name: name_${lang}
            }
         }
         rates
         {
            rate
            comment
            created_at
            user
            {
               username
            }
         }
         rate
         name:name_${lang}
         vendor_id
         rateCount
         badge{
            id
            name:name_${lang}
            color
         }
      }

   }`;



};



export const GET_RELATED_PRODUCTS_QUERY = (cat_id: number, lang: string)=>{


   return gql`
   {
      products(sub_category_id: "${cat_id}", limit: 8, Rand: "true")
      {
         id
         name: name_${lang}
         price
         rate
         rateCount
         brand
         {
            name: name_${lang}
         }
         badge{
          id
          name:name_${lang}
          color
       }
         photo
      }
   }
   `;


};



export const ProductListBySubcategory = (SubCat:number,page:string,orderBy:string, lang?: string) => {

   if ( SubCat > 0 )
   {

      return gql `
      {
         products(sub_category_id: "${SubCat}",${page},${orderBy}){
         name: name_${lang}
         discount
         photo
         id
         rate
         rateCount
         price
         brand {name:name_${lang}}
         products_photos {photo}
         offers{
            id
            percentage
            product_id
            }
         }
      }`;

   }
   else
   {

      return gql `
      {
         products(${page},${orderBy}){
         name: name_${lang}
         discount
         photo
         id
         rate
         rateCount
         price
         brand {name:name_${lang}}
         products_photos {photo}
         offers{
            id
            percentage
            product_id
            }
         }
      }`;

   }

};

export const SpecficationsOptionsbyCategory = (CatId:number, lang?: string) => gql `{ specifications(sub_category_id: ${CatId})
{
   id
   name: name_${lang}
   specifications_options
   {
    name: name_${lang}
    id
   }
}}`;

export const AttributesListByCategory = (CatId:number, lang: string) => gql ` {


  categories(id: "${CatId}") {
      id
      name:name_${lang}
      mSpecifications{
          id
          name:name_${lang}
          specifications_options{
              id
              name:name_${lang}
            }
      }
      mBrands{
        id
        name:name_${lang}
    }
    mAttributes{
      id
      name:name_${lang}
      attributes_options{
          id
          name:name_${lang}
        }
  }
  }




}



`
export const AttributesListBySubCategory = (SubCatId:number, lang: string) => gql ` {


  subCategories(id: "${SubCatId}") {
      id
      name:name_${lang}
      mSpecifications{
          id
          name:name_${lang}
          specifications_options{
              id
              name:name_${lang}
            }
      }
      mBrands{
        id
        name:name_${lang}
    }
    mAttributes{
      id
      name:name_${lang}
      attributes_options{
          id
          name:name_${lang}
        }
  }
  }




}



`
export const FilterList = (data:FilterObject, lang: string)=> {

   if ( data.SubCatId!!  > 0 )
   {

      return gql `{
         products(Function: "Filters",${data.orderby},${data.page},sub_category_id: "${data.SubCatId}") {
            name:name_${lang}
            discount
            photo
            id
            rate
            brand {name:name_${lang}}

            rateCount
            price
               product_attributes {  attributes_options_id  }
               products_specifications { specification_options_id  }
         }
      }`;

   }
   else
   {

      return gql `{
         products(Function: "Filters",${data.orderby},${data.page}) {
            name:name_${lang}
            discount
            photo
            id
            rate
            rateCount
            brand {name:name_${lang}}

            price
               product_attributes {  attributes_options_id  }
               products_specifications { specification_options_id  }
         }
      }`;

   }

};


export const BrandsForFilter = (subCat:number, lang: string) => gql `
{
  subCategories(id:"${subCat}") {
      mBrands{
          id
          name:name_${lang}
      }
  }
}
`

export const BrandsForCatFilter = (Cat:number, lang: string) => gql `

{
  brands(category_id:"${Cat}") {
    name:name_${lang}
    id
  }
}`

export const CheckFavourite = (user_id:number , product_id: number) => gql `{

      favorites (user_idEq: "${user_id}" product_id: "${product_id}")
      {
         id
         product{
            id
         }
      }

}`


export const ADD_FAVOURITE_QUERY = gql `{

   favorites (Function:"Add")
   {
      product
      {
         id
      }
   }
}`;


export const REMOVE_FAVOURITE_QUERY = gql `{

   favorites (Function:"Delete")
   {
      product
      {
         id
      }
   }
}`;

export const GET_PAYMENT_TYPES_QUERY = (lang: string)=> {

   return gql `
   {
       vendorgatewaysmodels{
           id
           photo
           name:name_${lang}

           PaymentTypes {
               id
               name:name_${lang}
               end_point
               webhook_callback
           }
       }
   }`
};




export const get_kasheir_payment_Query = () => {

   return gql `
   {

    KashierModels(Vendor_Id_Eq:"560" Vendor_Code_Eq:"0f69f8c0-47c4-11ee-a71b-ac1f6bfd5a3b") {

        id
        M_Id
        Api_Key

    }

    }`
};
